import { useCallback, useEffect, useId, useState } from "react"
import { PlayerEvent, playerStore } from "src/store/PlayerStore"

import { captureSentryException } from "../../utilities/sentry"

export const usePlayer = () => {
  const videoRef = playerStore((state) => state.videoRef)
  const setEventListener = playerStore((state) => state.setEventListener)
  const removeEventListener = playerStore((state) => state.removeEventListener)
  const duration = playerStore((state) => state.duration)

  const [paused, setPaused] = useState(videoRef ? videoRef.paused : false)

  // used to identify the hook to the listeners
  // It also leads to each hook being able to subscribe to each action ONCE
  const uniqueId = useId()

  const play = useCallback(() => {
    if (videoRef)
      videoRef.play().catch((e) => {
        console.log(e)
        captureSentryException(e)
      })
  }, [videoRef])

  const pause = useCallback(() => {
    try {
      if (videoRef) videoRef.pause()
    } catch (e) {
      console.log(e)
      captureSentryException(e)
    }
  }, [videoRef])

  const seek = useCallback(
    (time: number, relative = false) => {
      if (videoRef)
        videoRef.currentTime = time + (relative ? videoRef.currentTime : 0)
    },
    [videoRef],
  )

  useEffect(() => {
    setEventListener(PlayerEvent.Play, () => setPaused(false), uniqueId)
    setEventListener(PlayerEvent.Pause, () => setPaused(true), uniqueId)
    return () => {
      removeEventListener(PlayerEvent.Play, uniqueId)
      removeEventListener(PlayerEvent.Pause, uniqueId)
    }
  }, [])

  return { play, pause, paused, seek, duration }
}
